import { Compass, FileSignature, Globe2, Handshake, MapPin, Users } from "lucide-react";
import { Reveal } from "./Reveal";
import { UI } from "@/i18n/copy";
import { useLang } from "@/i18n/LanguageContext";

const ICONS = [Handshake, Globe2, Compass, Users, MapPin, FileSignature];

export const Brokerage = () => {
  const { lang } = useLang();
  const t = UI[lang].brokerage;

  return (
    <section id="brokerage" data-testid="brokerage-section" className="scroll-mt-20 bg-black text-white">
      <div className="mx-auto grid max-w-7xl gap-16 px-5 py-24 sm:px-8 sm:py-32 lg:grid-cols-[1fr_1.4fr]">
        <div className="lg:sticky lg:top-28 lg:self-start">
          <Reveal>
            <p className="font-mono-label text-[11px] uppercase tracking-[0.3em] text-white/50">
              {t.eyebrow}
            </p>
            <h2 className="mt-6 text-4xl font-black uppercase leading-[1] tracking-tight text-white sm:text-5xl lg:text-6xl">
              {t.headingA}{" "}
              {lang === "en" ? (
                <span className="font-script normal-case tracking-normal">{t.accent}</span>
              ) : (
                t.accent
              )}
            </h2>
            <p className="mt-8 max-w-sm text-base leading-relaxed text-white/55">{t.side}</p>
          </Reveal>
        </div>

        <div className="divide-y divide-white/10 border-y border-white/10">
          {t.items.map((item, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={item.title} delay={i * 0.06}>
                <div
                  className="group flex items-start gap-6 py-8"
                  data-testid={`brokerage-item-${i + 1}`}
                >
                  <span className="mt-1 inline-flex h-12 w-12 shrink-0 items-center justify-center rounded-full border border-white/15 transition-colors duration-300 group-hover:bg-white group-hover:text-black">
                    <Icon className="h-5 w-5" />
                  </span>
                  <div>
                    <h3 className="text-xl font-bold tracking-tight text-white sm:text-2xl">
                      {item.title}
                    </h3>
                    <p className="mt-2 max-w-xl text-sm leading-relaxed text-white/60 sm:text-base">
                      {item.desc}
                    </p>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
